import React from "react"
import CCOCard from "../../fundamentals/CCOCard";
import {metaDataElementWithId} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import ProductTeaserCardContent from "./ProductTeaserCardContent";
import {SosDonationProduct} from "../../../../packages/graphql-layer/src";

interface Props {
    item: SosDonationProduct,
    descriptionCharLimit?: number
    horizontal?: boolean
}

/**
 * Teasercard für Gridlayout
 */
function ProductTeaserCard(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    if (props.item != null) {
        return <CCOCard dataCypress='productTeaserCard' item={props.item}
                        padding={0}
                        hasFocusedStyle {...metaDataElementWithId(isPreview, props.item.id)}>
            <ProductTeaserCardContent item={props.item}
                                      horizontal={props.horizontal}
                                      descriptionCharLimit={props.descriptionCharLimit}/>
        </CCOCard>
    } else {
        return null
    }
}

export default ProductTeaserCard


